import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Collapsible from '../collapsible'
import Validators from '../../utils/validators'

@observer(['carriers'])
export default class Carriers extends Component {

  constructor(props) {
    super(props)

    this.props.carriers.loadAllCarriers()
  }

  newCarrier(row) {
    this.props.carriers.newCarrier(row.name)
  }

  updateCarrier(row, cellText, cellValue) {
    this.props.carriers.updateCarrier(row.id, cellValue)
  }

  deleteCarrier(id) {
    if (confirm('Are you sure you want to delete this Carrier?')) {
      this.props.carriers.deleteCarrier(id)
    }
  }

  formatActions(cell, row) {
    return <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteCarrier(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
  }

  render() {
    const options = {
      onAddRow: this.newCarrier.bind(this)
    }

    const carriersTable = (
      <BootstrapTable
          data={ this.props.carriers.data }
          striped={ true }
          hover={ true }
          pagination={ true }
          search={ true }
          exportCSV={ true }
          options={ options }
          insertRow={ true }
          bordered={ false }
          cellEdit={ { mode: 'click', blurToSave: false, afterSaveCell: this.updateCarrier.bind(this) } } >
        <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="name" dataSort={ true } editable={{ validator: Validators.validString }}>Name</TableHeaderColumn>
        <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
      </BootstrapTable>
    )

    return (
      <div>
        <Collapsible title="Carriers" content={ carriersTable } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/carriers.js